import { requireField } from './validators';

export default class InventoryAssignment {
  constructor(data = {}) {
    requireField(data.assignedToType, 'inventory.assignedToType');
    requireField(data.assignedToId, 'inventory.assignedToId');
    requireField(data.checkoutDate, 'inventory.checkoutDate');

    this.id = data.id || `assign-${Math.random().toString(36).slice(2, 9)}`;
    this.assignedToType = data.assignedToType; // 'student' | 'staff'
    this.assignedToId = data.assignedToId;
    this.assignedToName = data.assignedToName || '';
    this.checkoutDate = data.checkoutDate;
    this.dueDate = data.dueDate || null;
    this.expectedReturnDate = data.expectedReturnDate || null;
    this.checkinDate = data.checkinDate || null;
    this.notes = data.notes || '';
  }

  get isActive() {
    return !this.checkinDate;
  }

  toJSON() {
    return { ...this };
  }
}
